import App from '../main';
import { Ball } from './ball';
import { Delivery, DeliverySystem, OutcomeName, BallAnimation } from './delivery';
import * as AppInfo from '../../package.json';
import ObjectiveBallInfo from './objective-ball-info';
import ObjectiveRatings from './objective-ratings';
import { Tweens, Data } from 'phaser';
import { SDKManager } from './SDKManager';
import { LevelManager } from './level-manager';
import MenuScene from './menu-scene';
import { GAME_STATE } from './Enums';
import InGameHUD from './ingame-hud-scene';
import ObjectiveScene from './objective-scene';

export enum InputTrigger { Left, Right, None }
export enum ShotType { Early, EarlyShot, PerfectShot, LateShot, Late }
export enum FakeInput { None, Wrong, Right }

const gamesnacks = window.GameSnacks;

export default class Game extends Phaser.Scene {

    public static gameState: number = GAME_STATE.MAIN_MENU;
    public static instance: Game;

    constructor() {
        super('Game');
    }

    init(data: any) {
        this.objectiveIndex = data.ObjectiveIndex;

        /*this.scale.on('enterfullscreen', ()=> {
            this.scale.lockOrientation('landscape-primary');
        });

        this.scale.startFullscreen();*/
    }

    preload() {
        Game.instance = this;
        // ObjectiveScene.instance.wakeUpWebAudioApi();
        let loadingScreen = document.getElementById('loading-screen');
        let loaderText = document.getElementById('loader-text');
        let loaderBar = document.getElementById('loader-bar');

        let item = document.getElementById('item');

        loadingScreen.classList.remove('hide');

        this.load.on('progress', function (value) {
            let percent = Math.floor((value * 100)) + "%"
            loaderBar.style.width = percent;
            loaderText.innerText = percent
        });

        this.load.on('fileprogress', function (file) {
            item.innerText = "Loading";//file.src;

        });

        this.load.on('complete', function () {
            loadingScreen.classList.add('hide');
        });

        this.load.image('stadium-lords', 'stadiums/export.png');
        this.load.image('clouds', 'stadiums/clouds.png');
        this.load.image('sky', 'stadiums/sky.png');
        this.load.atlas('crowd', 'stadiums/crowd.png', 'stadiums/crowd.json');

        this.load.image('stumps-bowler', 'stadiums/stumps-bowler.png');

        this.load.setPath('characters/fielder');
        this.load['spine']('fielder', 'Fielder.json', ['Fielder.atlas']);

        this.load.setPath('characters/umpire');
        this.load['spine']('umpire', 'Umpire.json', ['Umpire.atlas']);

        this.load.setPath('characters/batsman');
        this.load['spine']('batsman', 'batsman.json', ['batsman.atlas'], true);

        this.load.setPath('characters/bowler');
        this.load['spine']('bowler', 'bowler.json', ['bowler.atlas'], true);

        this.load.setPath('characters/stumps');
        this.load['spine']('stumps-batsman', 'stumps-batsman.json', ['stumps-batsman.atlas'], true);

        this.load.setPath();
        this.load.json('ball-animations', 'animations/ball-animations.json');

        this.load.image('ball', 'ball.png');
        this.load.image('ball-shadow', 'ball-shadow.png');

        this.load.audio('crowdAmbience', "audio/crowdAmbience.mp3");
        this.load.audio('buttonSFX', "audio/buttonSFX.mp3");
        this.load.audio('batWooshSFX', "audio/batWooshSFX.mp3");
        this.load.audio('batHitSFX', "audio/batHitSFX.mp3");
        this.load.audio('ballTravelSFX', "audio/ballTravelSFX.mp3");
        this.load.audio('crowdApplauseSFX', "audio/crowdApplauseSFX.mp3");
        this.load.audio('lbwSFX', "audio/lbwSFX.mp3");
        this.load.audio('stumpSFX', "audio/stumpSFX.mp3");
        this.load.audio('ballPitchSFX', "audio/ballPitchSFX.mp3");
        this.load.audio('duckOutSFX', "audio/duckOutSFX.mp3");
        this.load.audio('crowd_aww', "audio/crowd_aww.mp3");

        this.load.atlas('flares', 'flares.png', 'flares.json');

        //this.scene.start ('Canvas');
        this.scene.launch('InGameHUD');
        SDKManager.onGamePause(this.onGamePause.bind(this));
        SDKManager.onGameResume(this.onGameResume.bind(this));
    }

    onGamePause() {
        App.isMute = this.game.sound.mute = true;
        this.game.events.emit('onPauseButton');
        this.scene.pause()
        console.log("Game Pause on game script")
    }
    onGameResume() {
        this.checkAudioAfterAd();
        this.game.events.emit('onResumeButton');
        this.scene.resume();
        console.log("Game Resume")
    }
    public checkAudioAfterAd() {
        let isAudioEnabled: boolean = true;
        console.log("Audio Enabled:", isAudioEnabled)
        if (SDKManager.local) {
            isAudioEnabled = true;
        }
        else {
            isAudioEnabled = gamesnacks.audio.isEnabled();
        }
        if (isAudioEnabled) {
            App.isMute = this.game.sound.mute = false;
            ObjectiveScene.instance.wakeUpWebAudioApi();
        }
        else {
            App.isMute = this.game.sound.mute = true;
        }
    }

    private image: Phaser.GameObjects.Image;
    // private phaserVersion: PhaserVersionText;

    create() {
        this.checkAudioAfterAd();
        window.addEventListener("visibilitychange", () => {
            if (document.hidden) {
                this.game.sound.mute = true;
            } else {
                App.isMute ? this.game.sound.mute = true : this.game.sound.mute = false;
                if (!App.isMute)
                    ObjectiveScene.instance.wakeUpWebAudioApi();
            }
        })

        this.cameras.main.setBackgroundColor('#ade6ff');

        DeliverySystem.setup(this.cache.json.get('ball-animations'));
        this.setupStadium();
        this.setupfielders();
        this.setupBowler();
        this.setupUmpire();
        this.setupStumpsBowler();

        this.setupBatsman();

        this.setupStumpsBatsman();
        this.setupBall();
        this.setupAudio();

        Delivery.RegisterPlayBallAnimationCallBack(this.playBallAnimation.bind(this))
        Delivery.RegisterPlayBatsmanAnimationCallBack(this.playBatsmanAnimation.bind(this));
        Delivery.RegisterSendOutcomeCallBack(this.sendOutcome.bind(this));

        this.startGame(this.objectiveIndex);

        this.scale.on('resize', (gameSize: any) => {
            this.resize(gameSize);
        })

        // this.phaserVersion = new PhaserVersionText(this, 0, 0, `${AppInfo.name} ${AppInfo.version}`);

        this.resize(this.scale.gameSize);
        this.game.events.on('onReadyGo', () => { this.changePlayState(PlayState.Prepare, 300); });
        this.game.events.on('onLeftArrow', this.sendLeftInputTrigger.bind(this));
        this.game.events.on('onRightArrow', this.sendRightInputTrigger.bind(this));
        this.game.events.on('onPauseButton', () => {
            this.scene.pause(); this.pauseTimer()
            if (this.ball.emitParticles) {
                this.ball.hideParticle();
            }
        });
        this.game.events.on('onResumeButton', () => { this.scene.resume(); this.resumeTimer() });
        this.game.events.on(Events.OnCompletedContinue, this.onCompletedContinue.bind(this));
        this.game.events.on(Events.OnRestart, this.onRestart.bind(this));
        this.game.events.on(Events.OnTutorialMode, this.onTutorialMode.bind(this));
        this.game.events.on(Events.OnExit, this.onCompletedContinue.bind(this));
        this.game.events.on(Events.OnObjectiveCompleted, this.onObjectiveCompleted.bind(this));

        this.game.events.on(Events.OnAdWatched, this.onWatchedAd.bind(this));

        this.events.on('sleep', this.reset.bind(this));
        this.events.on('wake', this.onAwake.bind(this));

    }

    private onExit() {
        if (this.scene.isActive('Game')) {
            this.scene.sleep('Game');
            this.scene.sleep('InGameHUD');
        }

        if (this.scene.isSleeping('MenuScene')) {
            this.scene.wake('MenuScene');
        } else {
            this.scene.launch('MenuScene');
        }
    }

    private onTutorialMode() {
        this.scene.pause();
    }



    private onAwake(sceneData: any, data: any) {
        this.checkAudioAfterAd();
        this.scene.wake('InGameHUD');
        this.objectiveIndex = data.ObjectiveIndex;
        this.startGame(this.objectiveIndex);
    }

    private onRestart() {
        this.stopTimer();
        this.startGame(this.objectiveIndex, true);
    }

    private onCompletedContinue() {
        this.game.sound.stopAll();
        App.isMute = this.game.sound.mute = true;
        this.stopTimer();
        this.scene.sleep('Game');
        this.scene.sleep('InGameHUD');
        if (this.objectiveIndex == -1) {
            this.onExit();
        } else {
            this.reset();
            this.scene.start('Objective');
        }
        this.game.events.off(Events.OnOutcomeChanged);
    }

    private resize(gameSize?: any) {
        if (Game.gameState == GAME_STATE.GAME) {

            this.cameras.main.startFollow(this.reference);

            this.cameras.main.width = gameSize.width;
            this.cameras.main.height = gameSize.height;

            // this.phaserVersion.x = this.cameras.main.width - 10;
            // this.phaserVersion.y = this.cameras.main.height - 10;

            this.cameras.main.stopFollow();
        }
    }

    update(deltaTime) {
        this.clouds.tilePositionX += 0.25;
    }

    public start(objectiveIndex: number) {
        this.objectiveIndex = objectiveIndex;
        this.reset();
    }

    public startGame(objectiveIndex: number, isRestarted: boolean = false) {
        // console.log('start game: ' + objectiveIndex);
        if (objectiveIndex == -1) {
            if (SDKManager.local) {
                this.game.isTutorial = (localStorage.getItem('cricket_mx_hasWatchedTutorial') == null);
                localStorage.setItem('cricket_mx_hasWatchedTutorial', 'true');
            }
            else {
                this.game.isTutorial = (SDKManager.getItem('cricket_mx_hasWatchedTutorial') == null);
                SDKManager.setItem('cricket_mx_hasWatchedTutorial', 'true');
            }
        }
        else if (objectiveIndex == 0) {
            this.game.isTutorial = true;
            InGameHUD.inputEnabled = false;

            // console.log('setting tutorial mode');
        } else {
            this.game.isTutorial = false;
            InGameHUD.inputEnabled = true;

        }
        this.start(App.GetParam('objective') ? App.GetParam('objective') : objectiveIndex);

        this.umpire.state.setAnimation(0, 'UmpireIdle', true);
        this.batsman.state.setAnimation(0, 'BattingIdle', false);
        this.stumpsBatsman.state.setAnimation(0, 'StumpsIdle', true);
        this.bowler.state.setAnimation(0, 'BowlingFastMediumIdle', true);
    }

    private reset() {
        if (this.gameTimer != null) {
            this.stopTimer();
            this.gameTimer = null;
            this.pauseTimer();
        }
        this.ball.emitParticles = false;
        this.ball.hideGraphics();
        this.ball.graphics.clear();
        if (this.changeStateTimer != null)
            this.changeStateTimer.stop();

        if (this.playBallAnimationTimer != null)
            this.playBallAnimationTimer.stop();

        this.ball.reset();
        this.ballsDelivered = 0;

        this.targetRuns = null;
        this.Runs = 0;

        this.totalOvers = null;
        this.Overs = 0;

        this.totalWickets = null;
        this.Wickets = 0;

        this.gameDuration = 0;
        this.boundaries = 0;
        this.sixes = 0;
        this.fours = 0;
        this.ballsMissed = 0;

        this.currentScore = 0;
        this.gameTimer = null;

        this.checkObjective();

        Game.crowdAmbience.stop();
        if (!App.isMute) {
            Game.crowdAmbience.play();
        }

        this.resetEntityAnimations(this.umpire, 'UmpireIdle');
        this.resetEntityAnimations(this.batsman, 'BattingIdle');
        this.resetEntityAnimations(this.stumpsBatsman, 'StumpsIdle');
        this.resetEntityAnimations(this.bowler, 'BowlingFastMediumIdle');

        [this.fielder1, this.fielder2, this.fielder3, this.fielder4].forEach(fielder => {
            this.resetEntityAnimations(fielder, 'FielderIdle');
        });
    }

    private resetEntityAnimations(entity: any, defaultAnimation: string) {
        // console.log('reset entity animations: ' + defaultAnimation);
        if (entity && entity.state) {
            // console.log('reset entity animations: ' + defaultAnimation);
            // Stop all animations
            entity.state.clearTrack(0);
            entity.skeleton.setToSetupPose();

            // Reset the time scale to default (1)
            entity.state.timeScale = 1;

            // Set the default animation
            entity.state.setAnimation(0, defaultAnimation, true);
        }
    }

    private fielderCelebration() {
        setTimeout(() => {
            this.fielder1.state.setAnimation(0, 'FielderCelebration', true);
            this.fielder2.state.setAnimation(0, 'FielderCelebration', true);
            this.fielder3.state.setAnimation(0, 'FielderCelebration', true);
            this.fielder4.state.setAnimation(0, 'FielderCelebration', true);
        }, 700)
    }

    private sendOutcome(outcome: number) {

        switch (outcome) {
            case OutcomeName.None:
                this.ball.emitParticles = false;
                this.ballsMissed++;
                this.currentScore = 0;
                break;

            case OutcomeName.One:
            case OutcomeName.Two:
            case OutcomeName.Three:
                this.ball.emitParticles = false;
                this.Runs += outcome;
                this.currentScore = outcome;
                if (!App.isMute) {
                    this.batHitSFX.play();
                }
                break;

            case OutcomeName.LBW:
                this.ball.emitParticles = false;
                this.ballsMissed++;
                this.Wickets++;
                this.currentScore = 0;
                if (!App.isMute) {
                    this.stumpSFX.play();
                    this.crowd_aww.play();
                }
                this.umpire.state.setAnimation(0, 'UmpireOut', false);
                this.fielderCelebration();
                break;
            case OutcomeName.Stumps:
                this.ball.emitParticles = false;
                this.ballsMissed++;
                this.Wickets++;
                this.currentScore = 0;
                if (!App.isMute) {
                    this.stumpSFX.play();
                    this.crowd_aww.play();
                }
                this.umpire.state.setAnimation(0, 'UmpireOut', false);
                this.fielderCelebration();
                break;
            case OutcomeName.Catch:
                this.ball.emitParticles = false;
                this.ballsMissed++;
                this.Wickets++;
                this.currentScore = 0;
                if (!App.isMute) {
                    this.crowd_aww.play();
                }
                this.umpire.state.setAnimation(0, 'UmpireOut', false);
                this.fielderCelebration();
                break;

            case OutcomeName.Four:
                this.cameras.main.shake(70, 0.008);
                this.ball.emitParticles = true;
                this.boundaries++;
                this.fours++;
                this.currentScore = outcome;
                this.Runs += this.currentScore;
                if (!App.isMute) {
                    this.batHitSFX.play();
                }
                this.crowdApplauseSFX.play({ delay: 0.5 });
                this.umpire.state.setAnimation(0, 'UmpireFour', false);
                this.vibrate(300);


                break;

            case OutcomeName.Six:
                this.cameras.main.shake(70, 0.008);
                this.ball.emitParticles = true;
                this.boundaries++;
                this.sixes++;
                this.currentScore = outcome;
                this.Runs += this.currentScore;
                if (!App.isMute) {
                    this.batHitSFX.play();
                }
                this.crowdApplauseSFX.play({ delay: 0.5 });
                this.umpire.state.setAnimation(0, 'UmpireSix', false);
                this.vibrate(500);
                break;
        }

        this.game.events.emit(Events.OnOutcomeChanged, outcome);
        this.outcomeSend = true;
    }

    public sendLeftInputTrigger() {
        // console.log('sendLeftInputTrigger: ', InGameHUD.inputType);
        if (InGameHUD.inputType !== "RIGHT") {
            this.scene.resume();
            this.ball.isTutorial = false;
            if (!this.game.isTutorial) {
                InGameHUD.inputEnabled = true;
            }
            else {
                InGameHUD.inputEnabled = false;

            }
            if (this.currentDelivery != null) {
                if (this.currentPlayState == PlayState.Delivery) {
                    //sprite.tint = 0x999999;
                    this.currentDelivery.updateInput(InputTrigger.Left);
                }
            }
        }
    }

    public sendRightInputTrigger() {
        // console.log('sendRightInputTrigger: ', InGameHUD.inputType);

        if (InGameHUD.inputType !== "LEFT") {

            if (InGameHUD.inputType !== "LEFT") {
                this.scene.resume();
                this.ball.isTutorial = false;
                if (!this.game.isTutorial) {
                    InGameHUD.inputEnabled = true;
                }
                else {
                    InGameHUD.inputEnabled = false;

                }
                if (this.currentDelivery != null) {
                    if (this.currentPlayState == PlayState.Delivery) {
                        //sprite.tint = 0x999999;
                        this.currentDelivery.updateInput(InputTrigger.Right);
                    }
                }
            }
        }
    }

    public static crowdAmbience: Phaser.Sound.BaseSound;
    private buttonSFX: Phaser.Sound.BaseSound;
    private batWooshSFX: Phaser.Sound.BaseSound;
    private batHitSFX: Phaser.Sound.BaseSound;
    private ballTravelSFX: Phaser.Sound.BaseSound;
    private crowdApplauseSFX: Phaser.Sound.BaseSound;
    private lbwSFX: Phaser.Sound.BaseSound;
    private stumpSFX: Phaser.Sound.BaseSound;
    private ballPitchSFX: Phaser.Sound.BaseSound;
    private duckOutSFX: Phaser.Sound.BaseSound;
    private crowd_aww: Phaser.Sound.BaseSound;

    private setupAudio() {
        Game.crowdAmbience = this.sound.add('crowdAmbience', { loop: true, volume: 0.4 });
        this.buttonSFX = this.sound.add('buttonSFX', { loop: false, volume: 1 });
        this.batWooshSFX = this.sound.add('batWooshSFX', { loop: false, volume: 0.35 });
        this.batHitSFX = this.sound.add('batHitSFX', { loop: false, volume: 0.35 });
        this.ballTravelSFX = this.sound.add('ballTravelSFX', { loop: false, volume: 1 });
        this.crowdApplauseSFX = this.sound.add('crowdApplauseSFX', { loop: false, volume: 0.4 });
        this.lbwSFX = this.sound.add('lbwSFX', { loop: false, volume: 0.75 });
        this.stumpSFX = this.sound.add('stumpSFX', { loop: false, volume: 1 });
        this.ballPitchSFX = this.sound.add('ballPitchSFX', { loop: false, volume: 1 });
        this.duckOutSFX = this.sound.add('duckOutSFX', { loop: false, volume: 1 });
        this.crowd_aww = this.sound.add('crowd_aww', { loop: false, volume: 1 });
    }

    public reference: Phaser.GameObjects.Image;
    public clouds: Phaser.GameObjects.TileSprite;

    private setupStadium() {
        var sky = this.add.image(App.MAX_WIDTH_HALF, App.MAX_HEIGHT_HALF, 'sky');
        sky.scale = 4;
        this.clouds = this.add.tileSprite(App.MAX_WIDTH_HALF, App.MAX_HEIGHT_HALF, 1920, 1080, 'clouds');
        this.reference = this.add.image(App.MAX_WIDTH_HALF, App.MAX_HEIGHT_HALF, 'stadium-lords');
        var frames = this.anims.create({ key: 'everything', frames: this.anims.generateFrameNames('crowd'), frameRate: 8, repeat: -1 });
        this.add.sprite(985, 360, 'crowd').setScale(1).play('everything');

        // console.log(frames);

    }

    private fielder1;
    private fielder2;
    private fielder3;
    private fielder4;

    private setupfielders() {

        this.fielder1 = this.add.spine(
            App.MAX_WIDTH_HALF - 200,
            App.MAX_HEIGHT_HALF - 55,
            'fielder', 'FielderIdle', true);

        this.fielder2 = this.add.spine(
            App.MAX_WIDTH_HALF + 220,
            App.MAX_HEIGHT_HALF - 55,
            'fielder', 'FielderIdle', true);

        this.fielder3 = this.add.spine(
            App.MAX_WIDTH_HALF - 600,
            App.MAX_HEIGHT_HALF - 10,
            'fielder', 'FielderIdle', true);

        this.fielder4 = this.add.spine(
            App.MAX_WIDTH_HALF + 600,
            App.MAX_HEIGHT_HALF - 15,
            'fielder', 'FielderIdle', true);

        this.fielder1.scale = 0.065;
        this.fielder2.scale = 0.075;
        this.fielder3.scale = 0.095;
        this.fielder4.scale = 0.09;
        this.fielder4.flipX = true

        this.fielder1.setDepth(5);
        this.fielder2.setDepth(5);
        this.fielder3.setDepth(5);
        this.fielder4.setDepth(5);
    }

    private bowler;
    private setupBowler() {

        this.bowler = this.add.spine(
            App.MAX_WIDTH_HALF + 100,
            App.MAX_HEIGHT_HALF - 20,
            'bowler', 'BowlingFastMediumIdle', true);


        //this.bowler.scale = 0.105;
        this.bowler.scaleX = -0.098;
        this.bowler.scaleY = 0.098;
        this.bowler.setDepth(5);

        this.bowler.state.addListener({
            event: this.bowlerEvent.bind(this)
        });

    }

    private bowlerEvent(entry: any, event: any) {
        if (event.data.name == "SpinBowl" || event.data.name == "FastBowl") {
            this.changePlayState(PlayState.Delivery);
        }
    }

    private umpire;
    private setupUmpire() {

        this.umpire = this.add.spine(
            App.MAX_WIDTH_HALF + 10,
            App.MAX_HEIGHT_HALF - 18,
            'umpire', 'UmpireIdle', true);

        this.umpire.scale = 0.105;

        this.umpire.setDepth(5);

        this.umpire.state.setAnimation(0, 'UmpireIdle', true);

    }

    private setupStumpsBowler() {
        let stumpsBowler = this.add.image(
            App.MAX_WIDTH_HALF + 10,
            App.MAX_HEIGHT_HALF - 18,
            'stumps-bowler');
        //stumpsBowler.tint = 0x000000;
        stumpsBowler.setOrigin(0.5, 1);
        stumpsBowler.setDepth(6);
    }

    private batsman: any;
    private setupBatsman() {
        this.batsman = this.add.spine(
            App.MAX_WIDTH_HALF - 80,
            App.MAX_HEIGHT_HALF + 240,
            'batsman', 'BattingIdle', true);
        this.batsman.scale = 0.315;
        this.batsman.scaleX = -this.batsman.scaleX;

        this.batsman.stateData.setMix('CoverDrive', 'BattingIdle', 0.1);

        this.batsman.state.setAnimation(0, 'BattingIdle', true);
        this.batsman.setDepth(8);
    }

    private stumpsBatsman;

    private setupStumpsBatsman() {
        this.stumpsBatsman = this.add.spine(
            App.MAX_WIDTH_HALF,
            App.MAX_HEIGHT_HALF + 320,
            'stumps-batsman', 'StumpsIdle', true);

        this.stumpsBatsman.setDepth(9)
    }

    private ball: Ball;
    private setupBall() {
        this.ball = new Ball(
            'ball',
            'ball-shadow',
            this);
    }

    public playBatsmanAnimation(animationName: string) {
        //GameApp._instance.shotPlayedText.text = 'ShotPlayed: ' + animationName;

        if (animationName == 'Stumps') {
            this.stumpsBatsman.state.setAnimation(0, 'Stumps', false);
        } else {
            this.batsman.state.setAnimation(0, animationName, false);
        }
    }

    private currentDelivery: Delivery;

    // 0.8 - Slow, Medium - 0.65, Fast - 0.55
    private deliverySpeed: number = 1;
    private bowlerType: BallType = BallType.Slow;

    get BowlerType(): BallType {
        return this.bowlerType;
    }

    set BowlerType(ballType: BallType) {
        this.bowlerType = ballType;
        var items = [-1, -1, -1, 1];

        this.bowler.scaleX = 0.098 * items[Math.floor(Math.random() * items.length)];
        this.game.events.emit(Events.OnBowlerTypeChanged, this.bowlerType);

    }

    private getDfilterByBowlerType(): string {
        if (this.BowlerType == BallType.Slow || this.BowlerType == BallType.Medium || this.BowlerType == BallType.Fast)
            return 'Pace';
        else if (this.BowlerType == BallType.LegSpin)
            return 'SpinLeg';
        else if (this.BowlerType == BallType.OffSpin)
            return 'SpinOff';

        return 'Pace';
    }

    private getDeliverySpeed(): number {
        if (this.BowlerType == BallType.Slow)
            return 0.8;
        else if (this.BowlerType == BallType.Medium) {
            return 0.65;
        } else if (this.BowlerType == BallType.Fast) {
            return 0.55;
        }

        return 1;
    }

    private outcomeSend: boolean = false;
    private currentPlayState: PlayState;

    get CurrentPlayState(): PlayState {
        return this.currentPlayState;
    }

    set CurrentPlayState(playState: PlayState) {
        this.currentPlayState = playState;
        this.game.events.emit(Events.OnPlayStateChanged, playState);
        // console.log('playState: ', playState);

        switch (playState) {

            case PlayState.SetBowler:
                this.pauseTimer();
                this.ball.emitParticles = false;
                this.ball.hideGraphics();
                break;

            case PlayState.Prepare:
                this.umpire.state.setAnimation(0, 'UmpireIdle', true);
                this.fielder1.state.setAnimation(0, 'FielderIdle', true);
                this.fielder2.state.setAnimation(0, 'FielderIdle', true);
                this.fielder3.state.setAnimation(0, 'FielderIdle', true);
                this.fielder4.state.setAnimation(0, 'FielderIdle', true);
                this.ball.emitParticles = false;
                this.ball.hideGraphics();
                this.outcomeSend = false;

                if (Delivery.USE_FAKE_INPUT) {
                    this.currentDelivery = DeliverySystem.getDelivery(Delivery.FAKE_DELIVERY);
                } else {
                    if (this.game.isTutorial) {
                        if (this.ballsDelivered == 0) {
                            this.currentDelivery = DeliverySystem.getDelivery('Pace-Full-Off1');
                            //Pace-Full-Off1
                        } else if (this.ballsDelivered == 1) {
                            this.currentDelivery = DeliverySystem.getDelivery('Pace-Full-Straight');
                        }
                    } else {
                        var dfilter = App.GetParam('dfilter');
                        this.currentDelivery = DeliverySystem.getDelivery(dfilter ? dfilter : this.getDfilterByBowlerType());
                        //this.currentDelivery = DeliverySystem.getDelivery('Pace-Full-Straight');
                    }
                }
                this.deliverySpeed = this.getDeliverySpeed();
                // Remove the ball
                this.ball.hide();

                this.changePlayState(PlayState.Ready, 500);
                this.batsman.state.setAnimation(0, 'BattingIdle', false);

                this.stumpsBatsman.state.setAnimation(0, 'StumpsIdle', true);

                if (this.currentDelivery.name.includes('Pace')) {
                    this.bowler.state.setAnimation(0, 'BowlingFastMediumIdle', true);
                } else {
                    this.bowler.state.setAnimation(0, 'BowlingSpinIdle', true);
                }
                break;

            case PlayState.Ready:
                console.log("Player Ready")
                // Set both the bowler and batsman in position, ball reset, what's the next delivery
                this.changePlayState(PlayState.BowlerRunning, 500);
                break;

            case PlayState.BowlerRunning:
                this.ball.emitParticles = false;
                this.resumeTimer();
                // start bowler running animation
                if (this.currentDelivery.name.includes('Pace')) {
                    this.bowler.state.setAnimation(0, 'BowlingFastMedium', false);
                } else {
                    this.bowler.state.setAnimation(0, 'BowlingSpin', false);
                }
                break;

            case PlayState.Delivery:
                // start the delivery animation
                //this.pauseTimer();
                this.currentDelivery.resetFrame();
                this.ball.reset();
                this.consoleText(this.currentDelivery.name)
                //console.log(this.currentDelivery.name);
                this.playBallAnimation(this.currentDelivery.ballAnimation, this.deliverySpeed);
                this.ballsDelivered++;

                this.Overs = Math.floor(this.ballsDelivered / 6);

                this.ball.frameUpdateCallback = this.currentDelivery.updateFrame.bind(this.currentDelivery);

                if (this.game.isTutorial && this.ballsDelivered <= 2) {

                    this.ball.isTutorial = true;
                    this.ball.perfectShotFrame = this.currentDelivery.getPerfectShotFrame();
                }
                break;
        }
    }

    private changeStateTimer: Tweens.Tween;

    public changePlayState(playState: PlayState, duration: number = 0) {
        if (this.changeStateTimer != null)
            this.changeStateTimer.stop();

        this.changeStateTimer = this.tweens.addCounter({
            from: 0,
            to: 1,
            duration: duration,
            ease: 'Linear',
            onComplete: () => { this.CurrentPlayState = playState; },
        });
    }

    private playBallAnimationTimer: Tweens.Tween;;

    public playBallAnimation(ballAnimation: BallAnimation, speed: number = 1) {
        if (this.playBallAnimationTimer != null)
            this.playBallAnimationTimer.stop();

        this.playBallAnimationTimer = this.tweens.addCounter({
            from: 0,
            to: 1,
            duration: 100,
            ease: 'Linear',
            onComplete: (() => {
                this.ball.playAnimation(ballAnimation, () => {
                    if (!ballAnimation.name.includes('_')) {
                        if (!this.outcomeSend) {
                            this.sendOutcome(OutcomeName.None);
                        }
                    }
                    this.checkObjective();
                }, speed)

            }).bind(this)
        });

        /*setTimeout(() => {
            this.ball.playAnimation(ballAnimation, () => {
                if (!ballAnimation.name.includes('_')) {
                    if (!this.outcomeSend) {
                        this.sendOutcome(OutcomeName.None);
                    }
                }
                this.checkObjective();
            }, speed)
        }, 125);*/
    }

    private runs: number = -1;
    private targetRuns: number;

    get Runs(): number {
        return this.runs;
    }

    set Runs(currentRuns: number) {
        this.runs = currentRuns;
        this.game.events.emit(Events.OnRunsChanged, this.runs, this.targetRuns);
    }

    private ballsDelivered: number = -1;

    private overs: number = -1;
    private totalOvers: number;

    get TotalOvers(): number {
        return this.totalOvers;
    }

    set TotalOvers(totalOvers: number) {
        this.totalOvers = totalOvers;
        this.game.events.emit(Events.OnTotalOversChanged, this.totalOvers);
    }

    get Overs(): number {
        return this.overs;
    }

    set Overs(currentOvers: number) {
        this.overs = currentOvers;
        this.game.events.emit(Events.OnOversChanged, this.overs, this.totalOvers);
    }

    private wickets: number = -1;
    private totalWickets: number;

    get Wickets(): number {
        return this.wickets;
    }

    set Wickets(currentWickets: number) {
        this.wickets = currentWickets;
        this.game.events.emit(Events.OnWicketsChanged, this.wickets, this.totalWickets);
    }

    private totalDuration: number;
    private gameDuration: number;
    private gameTimer: any;
    private isTimerPaused: boolean = false;

    private startTimer() {
        // if(this.gameTimer!=null){
        //     this.stopTimer();
        //     this.gameTimer = null;
        // }
        this.gameDuration = this.totalDuration;
        this.gameTimer = setInterval(this.timerUpdate.bind(this), 1000);
    }

    private stopTimer() {
        // if(this.gameTimer!=null){
        clearInterval(this.gameTimer);
        //     this.gameTimer = null;
        //     this.gameDuration = 0;
        //     console.log("STOPPED TIMER");
        // }
    }

    private pauseTimer() {
        this.isTimerPaused = true;
    }

    private resumeTimer() {
        this.isTimerPaused = false;
    }

    private timerUpdate() {
        if (this.isTimerPaused)
            return;

        this.gameDuration = this.gameDuration - 1;

        this.gameDuration = Phaser.Math.Clamp(this.gameDuration, 0, this.totalDuration);

        this.game.events.emit(Events.OnDurationChanged, this.gameDuration, this.totalDuration);

        if (this.gameDuration <= 0) {
            this.stopTimer();
        }
    }

    private boundaries: number = -1;
    private sixes: number = -1;
    private fours: number = -1;
    private ballsMissed: number = -1;

    private currentScore: number = -1;

    public objectiveIndex: number = -1;


    private hasWatchedAd: boolean = false;
    private hasCheckedForAds: boolean = false;

    public onWatchedAd(hasWatched: boolean) {
        this.consoleText(`watchedAd: ${hasWatched}`);
        if (hasWatched) {

        }
        this.hasWatchedAd = hasWatched;
        this.checkObjective();
    }

    public consoleText(text: string) {
        this.game.events.emit(Events.OnConsoleText, text);
    }

    public onObjectiveCompleted(levelNumber: number) {
        InGameHUD.instance.canShowPausePanel = false;
        console.log("On Obj Complete", InGameHUD.instance.canShowPausePanel)
        // console.log("objective completed", levelNumber);
        LevelManager.getInstance().setLevelCompleted(levelNumber);
    }

    public checkObjective() {

        let gameOver: boolean = false;
        var gameEndMessage: string;
        var ballsPerOver = 6;
        var objectiveMessage: string = '';
        var rating: number = 0;
        switch (this.objectiveIndex) {
            case -1:
                objectiveMessage = 'Endless mode';

                this.Wickets = this.wickets;

                if (this.Wickets == this.totalWickets) {

                    if (this.hasWatchedAd) {
                        this.Wickets--;
                        this.hasWatchedAd = false;
                        this.hasCheckedForAds = false;
                        this.checkObjective();
                        return;
                    }

                    if (!this.hasCheckedForAds) {
                        this.hasCheckedForAds = true;
                        return;
                    }

                    gameOver = true;
                    gameEndMessage = "You're out of wickets";
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Wickets = this.wickets; // This sends the target to UI system
                    return;
                }

                break;

            case 0:
                objectiveMessage = 'How to play';
                if (this.boundaries == 2) {
                    gameOver = true;
                    //gameEndMessage = 'Awesome!';
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);

                }
                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    return;
                }
                break;

            case 1:
                objectiveMessage = 'Chase 15 Runs';

                this.targetRuns = 15;
                if (this.Runs >= 15) {
                    gameOver = true;
                    //gameEndMessage = 'Reached 15 Runs';
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Runs = this.runs;
                    return;
                }
                break;

            case 2:
                objectiveMessage = 'How many boundaries in 3 overs';

                this.TotalOvers = 3;
                if (this.ballsDelivered == 3 * 6) {
                    gameOver = true;
                    //gameEndMessage = "Finished 3 overs " + ' boundaries: ' + this.boundaries;
                    if (this.boundaries == 0) {
                        gameEndMessage = "OBJECTIVE FAILED";
                        rating = 0;
                    } else {
                        gameEndMessage = "OBJECTIVE COMPLETED";
                        rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                    }
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Overs = this.overs;
                    return;
                }
                break;

            case 3:
                objectiveMessage = 'Highest score in 3 overs';

                this.TotalOvers = 3;
                if (this.ballsDelivered == 3 * 6) {
                    gameOver = true;
                    //gameEndMessage = "Finished 3 overs " + ' total score: ' + this.Runs;
                    if (this.runs == 0) {
                        gameEndMessage = "OBJECTIVE FAILED";
                        rating = 0;
                    } else {
                        gameEndMessage = "OBJECTIVE COMPLETED";
                        rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                    }
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Overs = this.overs;
                    return;
                }
                break;

            case 4:
                objectiveMessage = 'Last an over without missing a ball';

                if (this.ballsMissed > 0) {
                    gameOver = true;
                    //gameEndMessage = "Ball missed, objective failed ";
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                this.TotalOvers = 1;
                if (this.ballsDelivered == 1 * 6) {
                    gameOver = true;
                    //gameEndMessage = "Objective completed, survived without missing a ball.";
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Overs = this.overs;
                    return;
                }
                break;

            case 5:
                objectiveMessage = 'Score 20 runs in 3 overs';

                this.targetRuns = 20;
                if (this.Runs >= 20) {
                    gameOver = true;
                    //gameEndMessage = "Objecive completed, Scored 20 runs";
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }

                this.TotalOvers = 3;
                if (this.ballsDelivered == 3 * 6) {
                    gameOver = true;
                    //gameEndMessage = "Objective failed, couldn't score 20 runs in 3 overs";
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Runs = this.runs;
                    this.Overs = this.overs;
                    return;
                }
                break;

            case 6:
                objectiveMessage = 'Score as many 6s in 4 overs';

                this.TotalOvers = 4;
                if (this.ballsDelivered == 4 * 6) {
                    gameOver = true;
                    //gameEndMessage = 'Finished 4 overs ' + ' total sixes: ' + this.sixes;
                    if (this.Runs == 0) {
                        gameEndMessage = "OBJECTIVE FAILED";
                        rating = 0;
                    } else {
                        gameEndMessage = "OBJECTIVE COMPLETED";
                        rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                    }
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Overs = this.overs;
                    return;
                }
                break;

            case 7:
                objectiveMessage = 'Score as many consecutive boundaries';

                if (this.ballsDelivered > 0) {
                    if (!(this.currentScore == 6 || this.currentScore == 4)) {
                        gameOver = true;
                        // gameEndMessage = "It's not a boundary, total boundarties: " + this.boundaries;
                        if (this.boundaries < 1) {
                            gameEndMessage = "OBJECTIVE FAILED";
                            rating = 0;
                        } else {
                            gameEndMessage = "OBJECTIVE COMPLETED";
                            rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                        }
                    }
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    return;
                }
                break;

            case 8:
                objectiveMessage = 'Last 60 seconds without getting out';

                if (this.gameTimer == null) {
                    this.totalDuration = 60;
                    this.pauseTimer();
                    this.startTimer();
                }

                if (this.gameDuration <= 0) {
                    gameOver = true;
                    //gameEndMessage = "Objective complete, surived 60 seconds";
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }

                this.totalWickets = 1;

                if (this.Wickets >= 1) {
                    gameOver = true;
                    this.stopTimer();
                    //gameEndMessage = "Objecive failed, survived: " + this.gameDuration;
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);

                    return;
                }
                break;

            case 9:
                objectiveMessage = 'Score 50 runs in 7 overs';

                this.targetRuns = 50;
                if (this.Runs >= 50) {
                    gameOver = true;
                    //gameEndMessage = "Objective completed, you scored " + this.Runs + " in " + this.Overs + " overs";
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }

                this.TotalOvers = 7;
                if (this.ballsDelivered == 7 * 6) {
                    gameOver = true;
                    //gameEndMessage = "Objective failed, didn't score 50 runs in 7 overs";
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Runs = this.runs;
                    this.Overs = this.overs;
                    return;
                }

                break;

            case 10:
                objectiveMessage = 'Play till you miss a ball or get out';

                this.totalWickets = 1;
                // if (this.Wickets >= 1) {
                //     gameOver = true;
                //     //gameEndMessage = "You're out. Balls: " + this.ballsDelivered;

                //     rating = ObjectiveRatings.GetRatings(this.objectiveIndex, { runs: this.ballsDelivered });
                //     if (rating == 0) {
                //         gameEndMessage = "OBJECTIVE FAILED";
                //     } else {
                //         gameEndMessage = "OBJECTIVE COMPLETED";
                //     }
                // }

                // if (this.ballsMissed >= 1) {
                //     gameOver = true;
                //     gameEndMessage = "You missed a ball. Balls: " + this.ballsDelivered;
                //     rating = ObjectiveRatings.GetRatings(this.objectiveIndex, { runs: this.ballsDelivered });
                //     if (rating == 0) {
                //         gameEndMessage = "OBJECTIVE FAILED";
                //     } else {
                //         gameEndMessage = "OBJECTIVE COMPLETED";
                //     }
                // }
                if (this.Wickets >= 1 || this.ballsMissed >= 1) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }
                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Wickets = this.wickets;
                    return;
                }
                break;

            case 11:
                objectiveMessage = 'Try to hit more than 6 sixes in 3 overs';
                if (this.sixes >= 6) {
                    gameOver = true;
                    //gameEndMessage = "Objective completed. You scored 6 sixes";
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }

                this.TotalOvers = 3;
                if (this.ballsDelivered == 3 * 6) {
                    gameOver = true;
                    //gameEndMessage = "Objective failed. You didn't score 6 sixes";
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Overs = this.overs;
                    return;
                }
                break;

            case 12:
                // if 0 it means losing

                objectiveMessage = 'Two overs to score as many runs as possible';

                this.TotalOvers = 2;
                if (this.ballsDelivered == 2 * 6) {
                    gameOver = true;
                    //gameEndMessage = "Objective compelted, you scored" + this.Runs + " in 2 overs";
                    if (this.Runs == 0) {
                        gameEndMessage = "OBJECTIVE FAILED";
                        rating = 0;
                    } else {
                        gameEndMessage = "OBJECTIVE COMPLETED";
                        rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                    }
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Overs = this.overs;
                    return;
                }
                break;

            case 13:
                // if 0 it means losing

                objectiveMessage = 'Hit as many boundaries you can in 2 overs';

                this.TotalOvers = 2;
                if (this.ballsDelivered == 2 * 6) {
                    gameOver = true;
                    //gameEndMessage = "Objective compelted, total boundaries" + this.boundaries + " in 2 overs";
                    if (this.boundaries == 0) {
                        gameEndMessage = "OBJECTIVE FAILED";
                        rating = 0;
                    } else {
                        gameEndMessage = "OBJECTIVE COMPLETED";
                        rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                    }
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Overs = this.overs;
                    return;
                }
                break;

            case 14:
                // 0 is losing
                objectiveMessage = 'Score as many 6s as possible in 2 overs'

                this.TotalOvers = 2;
                if (this.ballsDelivered >= 2 * 6) {
                    gameOver = true;
                    //gameEndMessage = "Objective completed. You hit sixes: " + this.sixes;
                    if (this.sixes == 0) {
                        gameEndMessage = "OBJECTIVE FAILED";
                        rating = 0;
                    } else {
                        gameEndMessage = "OBJECTIVE COMPLETED";
                        rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                    }
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Overs = this.overs;
                    return;
                }
                break;

            case 15:
                objectiveMessage = 'Chase 30 runs in 3 overs without losing more than 3 wickets';

                this.TotalOvers = 3;
                if (this.ballsDelivered >= 3 * 6) {
                    gameOver = true;
                    //gameEndMessage = "Objective failed. Couln't chase 30 runs in 3 overs";
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                this.totalWickets = 3;
                if (this.Wickets >= 3) {
                    gameOver = true;
                    //gameEndMessage = "Objective failed Couldn't chase 30 runs in 3 overs in 3 wickets";
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                this.targetRuns = 30;
                if (this.Runs >= 30) {
                    gameOver = true;
                    //gameEndMessage = "Objective completed. Score: " + this.Runs + " Chased 30 overs in within 3 overs";
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Overs = this.overs;
                    this.Wickets = this.wickets;
                    this.Runs = this.runs;
                    return;
                }
                break;

            case 16:
                objectiveMessage = 'Score as many boundaries as possible in 3 overs without losing more than 3 wickets'

                this.totalWickets = 3;
                if (this.Wickets == 3) {
                    gameOver = true;
                    //gameEndMessage = "Objective failed Couldn't chase " + this.Runs + " runs in 3 overs in 3 wickets";
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                this.TotalOvers = 3;
                if (this.ballsDelivered == 3 * 6) {
                    gameOver = true;
                    //gameEndMessage = "Objective completed. Boundaries: " + this.boundaries + " scored in 3 overs";
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Wickets = this.wickets;
                    this.Overs = this.overs;
                    return;
                }

                break;

            case 17:
                objectiveMessage = 'Highest score in 3 overs without losing more than 3 wickets';

                this.totalWickets = 3;
                if (this.Wickets == 3) {
                    gameOver = true;
                    //gameEndMessage = "Objective failed. Lost 3 wickets within 3 overs";
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                this.TotalOvers = 3;
                if (this.ballsDelivered == 3 * 6) {
                    gameOver = true;
                    //gameEndMessage = "Objective completed. Score: " + this.Runs + " scored in 3 overs";
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Wickets = this.wickets;
                    this.Overs = this.overs;
                    return;
                }
                break;

            case 18:
                objectiveMessage = 'Last 2 overs in the net without missing a ball.';

                if (this.ballsMissed == 1) {
                    gameOver = true;
                    //gameEndMessage = "Objective failed. Couldn't last 2 overs";
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                this.TotalOvers = 2;
                if (this.ballsDelivered >= 2 * 6) {
                    gameOver = true;
                    //gameEndMessage = "Objective success. Survived 2 overs without missing a ball";
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Overs = this.overs;
                    return;
                }
                break;

            case 19:
                objectiveMessage = 'Score 20 runs in 3 overs without losing more than 3 wickets.';

                this.totalWickets = 3;
                if (this.Wickets >= 3) {
                    gameOver = true;
                    //gameEndMessage = "Objective failed. Couldn't score 20 runs in 3 overs";
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                this.TotalOvers = 3;
                if (this.ballsDelivered >= 3 * 6) {
                    gameOver = true;
                    //gameEndMessage = "Objective failed. Couldn't score 20 runs in 3 overs";
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                this.targetRuns = 20;
                if (this.Runs >= 20) {
                    gameOver = true;
                    //gameEndMessage = "Objective completed. Scored " + this.Runs + " in less than 3 overs and 3 wickets";
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Wickets = this.wickets;
                    this.Overs = this.overs;
                    this.Runs = this.runs;
                    return;
                }
                break;

            case 20:
                // If 0 you lose
                objectiveMessage = 'Score as many 6s in 3 overs without losing more than 3 wickets';

                this.totalWickets = 3;
                if (this.Wickets >= 3) {
                    gameOver = true;
                    //gameEndMessage = "Objective failed. You lost all the wickets.";
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                this.TotalOvers = 3;
                if (this.ballsDelivered >= 3 * 6) {
                    gameOver = true;
                    //gameEndMessage = "Objective completed. You hit sixes: " + this.sixes;
                    if (this.sixes == 0) {
                        gameEndMessage = "OBJECTIVE FAILED";
                        rating = 0;
                    } else {
                        gameEndMessage = "OBJECTIVE COMPLETED";
                        rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                    }
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Wickets = this.wickets;
                    this.Overs = this.overs;
                    return;
                }
                break;

            case 21:
                objectiveMessage = 'Score as many consecutive boundaries within 3 overs without losing more than 1 wicket.'

                if (this.ballsDelivered > 0) {
                    if (!(this.currentScore == 6 || this.currentScore == 4)) {
                        gameOver = true;
                        //gameEndMessage = "You have scored " + this.boundaries + " boundaries";
                        gameEndMessage = "OBJECTIVE FAILED";
                        rating = 0;
                    }
                }

                this.totalWickets = 1;
                if (this.Wickets >= 1) {
                    gameOver = true;
                    //gameEndMessage = "You have scored " + this.boundaries + " boundaries";
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                this.TotalOvers = 3;
                if (this.ballsDelivered >= 3 * 6) {
                    gameOver = true;
                    //gameEndMessage = "You have scored " + this.boundaries + " boundaries";
                    if (this.boundaries == 0) {
                        gameEndMessage = "OBJECTIVE FAILED";
                        rating = 0;
                    } else {
                        gameEndMessage = "OBJECTIVE COMPLETED";
                        rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                    }
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Wickets = this.wickets;
                    this.Overs = this.overs;
                    return;
                }
                break;

            case 22:
                objectiveMessage = 'Last 90 seconds without losing a wicket';

                if (this.gameTimer == null) {
                    this.totalDuration = 90;
                    this.pauseTimer();
                    this.startTimer();
                }

                if (this.gameDuration <= 0) {
                    gameOver = true;
                    //gameEndMessage = "Objective complete, surived 90 seconds";
                    if (this.runs == 0) {
                        gameEndMessage = "OBJECTIVE FAILED";
                        rating = 0;
                    } else {
                        gameEndMessage = "OBJECTIVE COMPLETED";
                        rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                    }
                }

                this.totalWickets = 1;
                if (this.Wickets >= 1) {
                    this.stopTimer();
                    gameOver = true;
                    //gameEndMessage = "Objecive failed, survived: " + this.gameDuration;
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Wickets = this.wickets;
                    return;
                }
                break;

            case 23:
                objectiveMessage = 'Score 60 runs in 5 overs without losing more than 3 wickets';

                this.totalWickets = 3;
                if (this.Wickets >= 3) {
                    gameOver = true;
                    //gameEndMessage = "Objective failed. Couldn't score 20 runs in 3 overs";
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                this.TotalOvers = 5;
                if (this.ballsDelivered >= 5 * 6) {
                    gameOver = true;
                    //gameEndMessage = "Objective failed. Couldn't score 20 runs in 3 overs";
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                this.targetRuns = 60;
                if (this.Runs >= 60) {
                    gameOver = true;
                    //gameEndMessage = "Objective completed. Scored " + this.Runs + " in less than 3 overs and 3 wickets";
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Wickets = this.wickets;
                    this.Overs = this.overs;
                    this.Runs = this.runs;
                    return;
                }
                break;

            case 24:
                //
                // If 0 you lose
                objectiveMessage = 'Score as many 6s in 3 overs without losing more than 2 wickets';

                this.totalWickets = 2;
                if (this.Wickets >= 2) {
                    gameOver = true;
                    //gameEndMessage = "Objective completed. You hit sixes: " + this.sixes;
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                this.TotalOvers = 3;
                if (this.ballsDelivered >= 3 * 6) {
                    gameOver = true;
                    //gameEndMessage = "Objective completed. You hit sixes: " + this.sixes;
                    if (this.sixes == 0) {
                        gameEndMessage = "OBJECTIVE FAILED";
                        rating = 0;
                    } else {
                        gameEndMessage = "OBJECTIVE COMPLETED";
                        rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                    }
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Wickets = this.wickets;
                    this.Overs = this.overs;
                    return;
                }
                break;

            case 25:
                //Last 120 seconds without losing a wicket or missing a ball
                objectiveMessage = 'Last 120 seconds without losing a wicket or missing a ball';

                if (this.gameTimer == null) {
                    this.totalDuration = 120;
                    this.pauseTimer();
                    this.startTimer();
                }

                if (this.gameDuration <= 0) {
                    this.stopTimer();
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }

                this.totalWickets = 1;
                if (this.Wickets >= 1 || this.ballsMissed >= 1) {
                    this.stopTimer();
                    gameOver = true;
                    //gameEndMessage = "Objecive failed, survived: " + this.gameDuration;
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Wickets = this.wickets;

                    return;
                }
                break;

            case 26:
                //Last 3 overs without losing a wicket.
                objectiveMessage = 'Last 3 overs without losing a wicket.';

                this.TotalOvers = 3;
                if (this.ballsDelivered >= 3 * 6) {
                    gameOver = true;
                    //gameEndMessage = "Objective completed. Lasted 3 overs";
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }

                this.totalWickets = 1;
                if (this.Wickets >= 1) {
                    gameOver = true;
                    //gameEndMessage = "Objecive failed, you lost a wicket ";
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Overs = this.overs;
                    this.Wickets = this.wickets;
                    return;
                }
                break;

            case 27:
                //Score 30 runs from 3 overs without losing more than 2 wicket
                objectiveMessage = 'Score 30 runs from 3 overs without losing more than 2 wicket';

                this.totalWickets = 2;
                if (this.Wickets >= 2) {
                    gameOver = true;
                    //gameEndMessage = "Objective failed. Couldn't score 30 runs in 3 overs";
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                this.TotalOvers = 3;
                if (this.ballsDelivered >= 3 * 6) {
                    gameOver = true;
                    //gameEndMessage = "Objective failed. Couldn't score 30 runs in 3 overs";
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                this.targetRuns = 30;
                if (this.Runs >= 30) {
                    gameOver = true;
                    //gameEndMessage = "Objective completed. Scored " + this.Runs + " in less than 3 overs and 2 wickets";

                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Wickets = this.wickets;
                    this.Overs = this.overs;
                    this.Runs = this.runs;
                    return;
                }
                break;

            case 28:
                //Score as many boundaries as possible from 2 overs without losing more than 2 wicket
                objectiveMessage = 'Score as many boundaries as possible from 2 overs without losing more than 2 wicket'

                this.totalWickets = 2;
                if (this.Wickets == 2) {
                    gameOver = true;
                    //gameEndMessage = "Objective failed Couldn't chase " + this.Runs + " runs in 2 overs in 3 wickets";
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                this.TotalOvers = 2;
                if (this.ballsDelivered == 2 * 6) {
                    gameOver = true;
                    //gameEndMessage = "Objective completed. Boundaries: " + this.boundaries + " scored in 2 overs";
                    if (this.boundaries == 0) {
                        gameEndMessage = "OBJECTIVE FAILED";
                        rating = 0;
                    } else {
                        gameEndMessage = "OBJECTIVE COMPLETED";
                        rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                    }
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Wickets = this.wickets;
                    this.Overs = this.overs;
                    return;
                }
                break;

            case 29:
                //Score as many 6s in a row as possible within 3 overs without losing more than 2 wickets.
                objectiveMessage = 'Score as many 6s in 3 overs without losing more than 2 wickets'

                this.totalWickets = 2;
                if (this.Wickets >= 2) {
                    gameOver = true;
                    //gameEndMessage = ""Objective failed. You lost wickets";"
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                this.TotalOvers = 3;
                if (this.ballsDelivered >= 3 * 6) {
                    gameOver = true;
                    //gameEndMessage = "Objective completed. You hit sixes: " + this.sixes;
                    if (this.sixes == 0) {
                        gameEndMessage = "OBJECTIVE FAILED";
                        rating = 0;
                    } else {
                        gameEndMessage = "OBJECTIVE COMPLETED";
                        rating = ObjectiveRatings.GetRatings(this.objectiveIndex, { sixes: this.sixes });
                    }
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Wickets = this.wickets;
                    this.Overs - this.overs;
                    return;
                }
                break;
            case 30:
                objectiveMessage = 'Score 75 runs in 5 overs while not losing more than 3 wickets';

                this.totalWickets = 3;
                this.TotalOvers = 5;
                this.targetRuns = 75;

                if (this.Wickets >= 3) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                if (this.ballsDelivered >= 5 * 6) {
                    gameOver = true;
                    gameEndMessage = this.Runs >= 75 ? "OBJECTIVE COMPLETED" : "OBJECTIVE FAILED";
                    rating = this.Runs >= 75 ? ObjectiveRatings.GetRatings(this.objectiveIndex) : 0;
                }

                if (this.Runs >= 75) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Wickets = this.wickets;
                    this.Overs = this.overs;
                    this.Runs = this.runs;
                    return;
                }
                break;

            case 31:
                objectiveMessage = 'Score 30 runs without losing a wicket';

                this.totalWickets = 1;
                this.targetRuns = 30;

                if (this.Wickets >= 1) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                if (this.Runs >= 30) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Wickets = this.wickets;
                    this.Runs = this.runs;
                    return;
                }
                break;

            case 32:
                objectiveMessage = 'Hit 5 sixes in a row';

                if (this.ballsMissed >= 1) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                if (this.sixes >= 5) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    return;
                }
                break;

            case 33:
                objectiveMessage = 'Hit 5 boundaries in a row';
                if (this.ballsMissed >= 1) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }
                if (this.ballsDelivered > 0 && !(this.currentScore == 4 || this.currentScore == 6)) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }
                if (this.boundaries >= 5) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }
                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    return;
                }
                break;

            case 34:
                objectiveMessage = 'Score 20 runs in 1 over';

                this.TotalOvers = 1;
                this.targetRuns = 20;
                if (this.runs >= 20) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }
                if (this.ballsDelivered == 6 && this.currentScore < 20) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Overs = this.overs;
                    this.Runs = this.runs;
                    return;
                }
                break;

            case 35:
                objectiveMessage = 'Score 50 runs in 10 balls';

                this.targetRuns = 50;
                this.TotalOvers = 2;

                if (this.ballsDelivered >= 10) {
                    gameOver = true;
                    gameEndMessage = this.Runs >= 50 ? "OBJECTIVE COMPLETED" : "OBJECTIVE FAILED";
                    rating = this.Runs >= 50 ? ObjectiveRatings.GetRatings(this.objectiveIndex) : 0;
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Runs = this.runs;
                    this.Overs = this.overs;
                    return;
                }
                break;

            case 36:
                objectiveMessage = 'Score 50 runs without losing a wicket';

                this.targetRuns = 50;
                this.totalWickets = 1;

                if (this.Wickets >= 1) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                if (this.Runs >= 50) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Wickets = this.wickets;
                    this.Runs = this.runs;
                    return;
                }
                break;

            case 37:
                objectiveMessage = 'Score 50 runs without missing a single ball';

                this.targetRuns = 50;

                if (this.ballsMissed >= 1) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                if (this.Runs >= this.targetRuns) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Runs = this.runs;
                    return;
                }
                break;

            case 38:
                objectiveMessage = 'Score 10 runs in 2 balls';

                this.targetRuns = 10;

                if (this.ballsDelivered >= 2) {
                    gameOver = true;
                    gameEndMessage = this.Runs >= 10 ? "OBJECTIVE COMPLETED" : "OBJECTIVE FAILED";
                    rating = this.Runs >= 10 ? ObjectiveRatings.GetRatings(this.objectiveIndex) : 0;
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Runs = this.runs;
                    return;
                }
                break;

            case 39:
                objectiveMessage = 'Last 2 overs without losing a wicket or missing a ball';

                this.TotalOvers = 2;
                this.totalWickets = 1;

                if (this.Wickets >= this.totalWickets || this.ballsMissed > 0) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                if (this.ballsDelivered >= this.totalOvers * 6) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Overs = this.overs;
                    this.Wickets = this.wickets;
                    return;
                }
                break;

            case 40:
                objectiveMessage = 'Hit boundaries on 3 consecutive spin balls';

                if (this.ballsMissed >= 1) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                if (this.ballsDelivered > 0) {
                    if (!(this.currentScore == 4 || this.currentScore == 6)) {
                        gameOver = true;
                        gameEndMessage = "OBJECTIVE FAILED";
                        rating = 0;
                    }
                }

                if (this.boundaries >= 3) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    return;
                }
                break;

            case 41:
                objectiveMessage = 'Score 25 runs off a spin bowler without losing a wicket';

                this.targetRuns = 25;
                this.totalWickets = 1;

                if (this.Wickets >= 1) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                if (this.Runs >= 25) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Wickets = this.wickets;
                    this.Runs = this.runs;
                    return;
                }
                break;

            case 42:
                objectiveMessage = 'Score 75 runs in 3 overs';

                this.TotalOvers = 3;
                this.targetRuns = 75;

                if (this.runs >= this.targetRuns) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }
                if (this.ballsDelivered == this.totalOvers * 6 && this.runs < this.targetRuns) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Overs = this.overs;
                    this.Runs = this.runs;
                    return;
                }
                break;

            case 43:
                objectiveMessage = 'Last 4 overs without losing a wicket';

                this.TotalOvers = 4;
                this.totalWickets = 1;

                if (this.Wickets >= 1) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                if (this.ballsDelivered >= this.totalOvers * 6) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Overs = this.overs;
                    this.Runs = this.runs;
                    return;
                }
                break;

            case 44:
                objectiveMessage = 'Score 70 runs in 2 overs';
                this.TotalOvers = 2;
                this.targetRuns = 70;

                if (this.runs >= this.targetRuns) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }
                if (this.ballsDelivered == this.totalOvers * 6 && this.runs < this.targetRuns) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Wickets = this.wickets;
                    this.Runs = this.runs;
                    return;
                }
                break;

            case 45:
                objectiveMessage = 'Score 75 runs without losing a wicket';
                this.targetRuns = 75;
                this.totalWickets = 1;

                if (this.Wickets >= this.totalWickets) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                if (this.Runs >= this.targetRuns) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Overs = this.overs;
                    this.Runs = this.runs;
                    return;
                }
                break;

            case 46:
                objectiveMessage = 'Score 30 runs in 1 over';
                this.TotalOvers = 1;
                this.targetRuns = 30;

                if (this.runs >= this.targetRuns) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }
                if (this.ballsDelivered == 6 && this.runs < this.targetRuns) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Overs = this.overs;
                    this.Wickets = this.wickets;
                    return;
                }
                break;

            case 47:
                objectiveMessage = 'Hit boundaries 6 consecutive spin balls';
                this.totalOvers = 1;

                if (this.ballsMissed >= 1) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }
                if (this.ballsDelivered > 0) {
                    if (!(this.currentScore == 4 || this.currentScore == 6)) {
                        gameOver = true;
                        gameEndMessage = "OBJECTIVE FAILED";
                        rating = 0;
                    }
                }
                if (this.boundaries >= 6) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }
                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Overs = this.overs;
                    return;
                }
                break;

            case 48:
                objectiveMessage = 'Last 3 overs without losing a wicket or a ball';
                this.TotalOvers = 3;
                this.totalWickets = 1;

                if (this.Wickets >= 1 || this.ballsMissed >= 1) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE FAILED";
                    rating = 0;
                }

                if (this.ballsDelivered >= this.totalOvers * 6) {
                    gameOver = true;
                    gameEndMessage = "OBJECTIVE COMPLETED";
                    rating = ObjectiveRatings.GetRatings(this.objectiveIndex);
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Overs = this.overs;
                    this.Wickets = this.wickets;
                    return;
                }
                break;

            case 49:
                objectiveMessage = 'Score 12 runs in 2 balls';
                this.targetRuns = 12;

                if (this.ballsDelivered >= 2) {
                    gameOver = true;
                    gameEndMessage = this.Runs >= 12 ? "OBJECTIVE COMPLETED" : "OBJECTIVE FAILED";
                    rating = this.Runs >= 12 ? ObjectiveRatings.GetRatings(this.objectiveIndex) : 0;
                }

                if (this.ballsDelivered % ballsPerOver == 0 && !gameOver) {
                    this.BowlerType = ObjectiveBallInfo.getBallType(this.objectiveIndex, this.ballsDelivered);
                    this.changePlayState(PlayState.SetBowler);
                    this.events.emit('objectiveMessage', objectiveMessage);
                    this.Overs = this.overs;
                    this.Wickets = this.wickets;
                    return;
                }
                break;
        }


        if (!gameOver) {
            // console.log("GAME OVER:",gameOver);
            this.changePlayState(PlayState.Prepare, 500);
        } else {
            this.game.events.emit(Events.OnGameOver, gameEndMessage, this.objectiveIndex, rating);
            if (gameEndMessage == "OBJECTIVE COMPLETED") {
                this.game.events.emit(Events.OnObjectiveCompleted, this.objectiveIndex + 1);
            }
        }
    }

    public vibrate(duration: number) {
        let vibrate = window.navigator.vibrate;
        if (vibrate !== undefined) {
            if ("vibrate" in navigator) {
                window.navigator.vibrate(duration);
            }
        }
    }


}

export enum PlayState { SetBowler, Prepare, Ready, BowlerRunning, Delivery }
export enum BallType { Slow, Medium, Fast, OffSpin, LegSpin }

export class PhaserVersionText extends Phaser.GameObjects.Text {
    constructor(scene: Phaser.Scene, x: number, y: number, text: string) {
        super(scene, x, y, text, {
            color: '#FFFFFF',
            fontSize: '32px'
        })
        scene.add.existing(this);
        //this.setOrigin(0, 0).setScrollFactor(0);
        this.setOrigin(1, 1).setScrollFactor(0);
    }
}

export enum Events {
    OnPlayStateChanged = 'onPlayerStateChanged',
    OnTutorialMode = 'onTutorialMode',
    OnBowlerTypeChanged = 'onBowlerTypeChanged',
    OnOversChanged = 'onOversChanged',
    OnRunsChanged = 'onRunsChanged',
    OnOutcomeChanged = 'onOutcomeChanged',
    OnWicketsChanged = 'onWicketsChanged',
    OnDurationChanged = 'onDurationChanged',
    OnGameOver = 'onGameOver',
    OnCompletedContinue = 'onCompletedContinue',
    OnRestart = 'onRestart',
    OnTotalOversChanged = "onTotalOversChanged",
    OnAdAvailable = "OnAdAvailable",
    OnWatchAd = "OnWatchAd",
    OnAdWatched = "OnAdWatched",
    OnConsoleText = "OnConsoleText",
    OnExit = "onExit",
    OnObjectiveCompleted = "onObjectiveCompleted",
    OnMute = "OnMute",
}

